<div class="tm" [ngStyle]="vars">
  <button type="button" class="tm-logo logo" [class.is-disabled]="logoDisabled" (click)="!logoDisabled && logoClick.emit()"
    aria-label="Home">
    <img *ngIf="logoUrl" [src]="logoUrl" alt="" appLogoTile>
  </button>

  <button type="button" *ngIf="liveEvent" class="tm-livetext" [class.is-disabled]="isPreview"
    (click)="pickEvent(liveEvent)"><span class="tm-live-tag">LIVE</span>{{ liveEvent.title }}</button>

  <div class="tm-spacer"></div>

  <nav class="tm-nav" aria-label="Main" (mouseleave)="hideUnderline()">
    <span class="tm-ul" aria-hidden="true" [class.is-on]="underline.on"
      [style.left.px]="underline.left" [style.width.px]="underline.width"></span>
    <div class="tm-market" (mouseleave)="leaveMarketplace()">
      <button #marketLink type="button" class="tm-link" [class.is-open]="marketplaceOpen" [class.is-disabled]="disableAccess"
        [attr.aria-expanded]="marketplaceOpen" (click)="toggleMarketplace(marketLink)" (mouseenter)="hoverMarketplace(marketLink)">
        {{ marketplaceText || 'Marketplace' }}
        <svg class="tm-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>
      </button>
      <div class="tm-pop tm-market-pop" *ngIf="marketplaceOpen" [class.has-events]="panelEvents.length">
        <div class="tm-dest">
          <button type="button" class="tm-pop-row" (click)="pickMarketplace('market')">
            <span class="tm-pop-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7z"></path><path d="M9 7a3 3 0 016 0"></path></svg></span>
            <span class="tm-pop-text"><strong>Merchandise</strong><small>Shop official gear</small></span>
          </button>
          <button type="button" class="tm-pop-row" (click)="pickMarketplace('event')">
            <span class="tm-pop-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M3 10h18M8 3v4M16 3v4"></path></svg></span>
            <span class="tm-pop-text"><strong>Events</strong><small>Tickets and live streams</small></span>
          </button>
        </div>
        <div class="tm-events" *ngIf="panelEvents.length">
          <div class="tm-pop-head">Coming up <button type="button" (click)="pickMarketplace('event')">All events</button></div>
          <ng-container *ngTemplateOutlet="eventRows; context: { $implicit: panelEvents }"></ng-container>
        </div>
      </div>
    </div>
    <button type="button" *ngIf="showCommunity" class="tm-link" [class.is-disabled]="disableAccess"
      (mouseenter)="moveUnderline($any($event.target))" (click)="!disableAccess && community.emit()">Community</button>
    <button type="button" *ngIf="show247" class="tm-link" [class.is-disabled]="isPreview"
      (mouseenter)="moveUnderline($any($event.target))"
      (click)="!isPreview && channel247.emit()"><span class="tm-live" aria-hidden="true"></span>24/7 Channel</button>
  </nav>

  <div class="tm-search">
    <label class="tm-search-box">
      <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg>
      <input #searchInput type="text" placeholder="Search events, teams, videos" aria-label="Search"
        [value]="searchText || ''" [disabled]="isPreview" (input)="onSearchInput($any($event.target).value)"
        (focus)="openSearchPanel()" (keydown.arrowdown)="suggestionList?.move(1, $event)"
        (keydown.arrowup)="suggestionList?.move(-1, $event)" (keyup.enter)="suggestionList?.pickActive() || submitSearch()">
      <kbd>/</kbd>
    </label>
    <div class="tm-pop tm-search-pop" *ngIf="searchPanelOpen && (showSuggestions || recentSearches.length || soonEvents.length)">
      <app-ic-search-suggestions *ngIf="showSuggestions" [groups]="suggestions" [loading]="suggestionsLoading" [failed]="suggestionsFailed"
        (pick)="searchPanelOpen = false; pickSuggestion.emit($event)"></app-ic-search-suggestions>
      <ng-container *ngIf="!showSuggestions && recentSearches.length">
        <div class="tm-pop-head">Recent</div>
        <div class="tm-chips">
          <button type="button" class="notranslate" *ngFor="let term of recentSearches" (click)="pickRecent(term)">{{ term }}</button>
        </div>
      </ng-container>
      <ng-container *ngIf="!showSuggestions && soonEvents.length">
        <div class="tm-pop-head">Starting soon</div>
        <ng-container *ngTemplateOutlet="eventRows; context: { $implicit: soonEvents }"></ng-container>
      </ng-container>
    </div>
  </div>

  <button type="button" *ngIf="showAffiliate" class="tm-affiliate" [class.is-disabled]="isPreview"
    (click)="!isPreview && affiliate.emit()">{{ affiliateLabel }}</button>

  <div class="tm-locale" [class.is-native]="isNative">
    <app-google-translate *ngIf="!isNative" class="tm-lang" [plain]="true" [settingsData]="settingsData"></app-google-translate>
    <ng-container *ngTemplateOutlet="currencyTpl"></ng-container>
  </div>

  <button type="button" class="tm-icon tm-phone-only" aria-label="Search, language and currency"
    [attr.aria-expanded]="phoneToolsOpen" (click)="togglePhoneTools()">
    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg>
  </button>

  <div class="tm-cart" *ngIf="showCart">
    <button type="button" class="tm-icon" [attr.aria-label]="'Cart, ' + cartCount + ' items'" (click)="cartClick.emit()">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 11h10.2L20 7H6.2"></path><circle cx="9" cy="19.5" r="1.3"></circle><circle cx="17" cy="19.5" r="1.3"></circle></svg>
      <span class="tm-badge">{{ cartCount }}</span>
    </button>
    <ng-content select="[cartPopup]"></ng-content>
  </div>

  <button type="button" *ngIf="showSignIn" class="tm-signin" [class.is-disabled]="isPreview"
    (click)="!isPreview && signIn.emit()">
    <span class="tm-signin-text">Sign in</span>
    <svg class="tm-signin-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"></circle><path d="M4 21c1-4 4.5-6 8-6s7 2 8 6"></path></svg>
  </button>

  <button type="button" *ngIf="showAvatar" id="arevea_sideNav" class="tm-avatar notranslate" [class.is-disabled]="isPreview"
    [class.has-photo]="!!profilePic" [style.background-image]="profilePic ? 'url(' + profilePic + ')' : null"
    aria-label="Account menu" (click)="!isPreview && profileToggle.emit()">{{ profilePic ? '' : initials }}</button>
</div>

<div class="tm-phone-tools" *ngIf="phoneToolsOpen" [ngStyle]="vars">
  <label class="tm-search-box tm-search-phone">
    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg>
    <input type="text" placeholder="Search events, teams, videos" aria-label="Search" [value]="searchText || ''"
      [disabled]="isPreview" (input)="onSearchInput($any($event.target).value)" (keyup.enter)="submitSearch()">
  </label>
  <button type="button" *ngIf="showAffiliate" class="tm-affiliate tm-affiliate-phone" [class.is-disabled]="isPreview"
    (click)="!isPreview && affiliate.emit()">{{ affiliateLabel }}</button>
  <div class="tm-locale" *ngIf="!isNative">
    <app-google-translate class="tm-lang" [plain]="true" [settingsData]="settingsData"></app-google-translate>
    <ng-container *ngTemplateOutlet="currencyTpl"></ng-container>
  </div>
</div>

<ng-template #eventRows let-list>
  <button type="button" class="tm-ev" *ngFor="let ev of list" [class.is-disabled]="isPreview" (click)="pickEvent(ev)">
    <span class="tm-date"><small>{{ ev.isLive ? 'Now' : (ev.start | date:'EEE') }}</small><b>{{ ev.start | date:'d' }}</b></span>
    <span class="tm-ev-text">
      <strong>{{ ev.title }} <i *ngIf="ev.isLive" class="tm-live-tag">LIVE</i></strong>
      <small>{{ ev.isLive ? 'Live now' : (ev.start | date:'MMM d · h:mm a') }}{{ ev.line ? ' · ' + ev.line : '' }}</small>
    </span>
  </button>
</ng-template>

<ng-template #currencyTpl>
  <div class="tm-currency" *ngIf="showCurrency">
    <button type="button" class="tm-chip notranslate" aria-haspopup="true" [attr.aria-expanded]="currencyOpen"
      aria-label="Currency" (click)="toggleCurrency()">{{ shortCurrency }}
      <svg class="tm-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>
    </button>
    <div class="tm-pop tm-currency-pop" *ngIf="currencyOpen">
      <input type="text" class="tm-pop-search" placeholder="Search currency" aria-label="Search currency"
        [(ngModel)]="currencySearch">
      <div class="tm-pop-list">
        <button type="button" class="tm-pop-item notranslate"
          *ngFor="let item of currencyList | filter: currencySearch:'currency'"
          (click)="pickCurrency(item.currency)">{{ item.currency }}</button>
      </div>
    </div>
  </div>
</ng-template>
